/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: queuesActions.ts (Queues)
 🗓️ Created: 2025-01-15
 🧩 Description:
    Shared helpers for Queues module actions.
    Used in Grid + Form views.

 🔧 Notes:
    - Refactored to use new API layer
    - Navigation helpers for duplicate functionality

 🔁 Last Updated: 2025-01-15 by Rodrigo Cuadra (Refactored)
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteQueueById as deleteQueueApi } from './api/queuesApi';

/**
 * Build the URL used to duplicate a Queue in the form.
 * Pattern: /pbx/call-center/queues/new?duplicate={id}
 */
export const getQueueDuplicateUrl = (id: string | number): string =>
  `/pbx/call-center/queues/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Queue id.
 */
export const navigateToQueueDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getQueueDuplicateUrl(id));
};

/**
 * Delete a Queue by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteQueueById = async (id: string | number): Promise<void> => {
  await deleteQueueApi(id);
};



